import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'vw-gdd-badge',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <span class="inline-flex items-center gap-0.5 text-[10px] font-medium px-1.5 py-0.5 rounded-full"
          [ngClass]="badgeClasses">
      {{ icon }} {{ 'gdd.badge.' + conditionBadge | translate }}
    </span>
  `,
})
export class GddBadgeComponent {
  @Input() conditionBadge: 'FAVORABLE' | 'NORMAL' | 'UNFAVORABLE' = 'NORMAL';

  get badgeClasses(): string {
    switch (this.conditionBadge) {
      case 'FAVORABLE': return 'text-[#317756] bg-[#E8F5E9]';
      case 'UNFAVORABLE': return 'text-[#C62828] bg-[#FFEBEE]';
      default: return 'text-[#F57F17] bg-[#FFF8E1]';
    }
  }

  get icon(): string {
    switch (this.conditionBadge) {
      case 'FAVORABLE': return '\u2191';
      case 'UNFAVORABLE': return '\u2193';
      default: return '\u2192';
    }
  }
}
